import React, { useEffect, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import NuDate from "./NuDate";
import NuAmount from "./NuAmount";
import Info from "../Icons/Info";
import { CalPercentage } from "./OtherFuction";
import { formatDisplaySno } from "./formatDisplaySno";

function TempCom({ label = "", value = 0, calculation = 0 }) {
  return (
    <tr className="w-full">
      <td className="w-[150px] py-1">{label}</td>
      <td className="w-[10px] py-1">:</td>
      <td className="min-w-[130px] py-1">
        {value}
        {label === "Duty" && calculation !== null && (
          <span>
            {" ("}
            <NuAmount value={calculation} />
            {")"}
          </span>
        )}
      </td>
    </tr>
  );
}

const HeaderInfoTooltip = ({ sub }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = React.useRef(null);

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + 6,
        left: Math.max(10, Math.min(window.innerWidth - 260, rect.left - 100)),
      });
      setShow(true);
    }
  };

  return (
    <div
      ref={triggerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
      className="cursor-pointer inline-block"
    >
      <Info color="white" />
      {show && (
        <div
          className="fixed z-[999999] font-medium border border-teal-700 text-black bg-white text-xs rounded-lg p-2 shadow-2xl min-w-[250px] pointer-events-none"
          style={{
            top: `${pos.top}px`,
            left: `${pos.left}px`,
          }}
        >
          <table className="text-left border-collapse w-full">
            <TempCom label="LCost" value={sub?.lCost || "0"} />
            <TempCom label="Other" value={sub?.others || "0"} />
            <TempCom label="Total" value={sub?.boxTotal || "0"} />
          </table>
        </div>
      )}
    </div>
  );
};

const InfoTooltip = ({ supplier }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, placeAbove: false });
  const triggerRef = React.useRef(null);

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const placeAbove = rect.top > 280;
      setPos({
        top: placeAbove ? rect.top - 8 : rect.bottom + 8,
        left: Math.max(10, Math.min(window.innerWidth - 365, rect.left - 170)),
        placeAbove,
      });
      setShow(true);
    }
  };

  return (
    <div
      ref={triggerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
      className="cursor-pointer inline-block"
    >
      <Info />
      {show && (
        <div
          className="fixed z-[999999] font-medium border border-teal-700 bg-white text-xs rounded-lg p-2 shadow-2xl min-w-[350px] text-black pointer-events-none"
          style={{
            top: `${pos.top}px`,
            left: `${pos.left}px`,
            transform: pos.placeAbove ? "translateY(-100%)" : "none",
          }}
        >
          <table className="text-left border-collapse w-full">
            <TempCom
              label="Supplier Price"
              value={`${supplier?.currencyLabel || ""} ${supplier?.unitPrice || "0"}`}
            />
            <TempCom
              label="Converted Price"
              value={<NuAmount value={supplier?.convertedPrice || "0"} />}
            />
            <TempCom
              label="Duty"
              value={`${supplier?.dutty || "0"}%`}
              calculation={
                supplier?.dutty && supplier?.convertedPrice
                  ? ((supplier?.convertedPrice / 100) * supplier?.dutty).toFixed(2)
                  : null
              }
            />
            <TempCom
              label="Trans. + Exp"
              value={<NuAmount value={supplier?.trans || "0"} />}
            />
            <TempCom
              label="Landing Cost"
              value={<NuAmount value={supplier?.landedCost || "0"} />}
            />
            <TempCom
              label="Final Unit Price"
              value={<NuAmount value={supplier?.LCSP || "0"} />}
            />
          </table>
        </div>
      )}
    </div>
  );
};

const QuoteComparisonModal = ({ isOpen, prId, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataView, setDataView] = useState([]);
  const [supplierList, setSuppliersList] = useState([]);
  const [stateValue, setStateValue] = useState([]);

  useEffect(() => {
    if (isOpen && prId) {
      setIsLoading(true);
      axiosInstance
        .get(`/supplier-quotations/quot-compare/${prId}`)
        .then((res) => {
          if (res.data?.data) {
            setDataView(formatDisplaySno(res.data.data.products || []));
            setSuppliersList(res.data.data.vendorNames || []);
            setStateValue(res.data.data.vendors || []);
          }
        })
        .catch((error) => {
          console.error("Error fetching quote comparison:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [isOpen, prId]);

  if (!isOpen) return null;
  console.log("dataView", dataView);

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in w-[98vw] h-[96vh] bg-white py-2 px-2 lg:py-4 lg:px-6 rounded-md shadow-lg">
        <div className="w-full flex justify-between items-center z-0 mb-3">
          <div className="flex items-center gap-4 flex-wrap">
            <h2 className="text-sm 2xl:text-base font-semibold">
              Quote Comparison
            </h2>
            <div className="flex gap-3 items-center">
              <span className="flex gap-1 items-center">
                <div className="w-4 h-4 border border-solid border-green-500 rounded-full bg-green-100"></div>
                <span className="text-xs text-gray-700">Lowest Price ,</span>
              </span>

              <span className="flex gap-1 items-center">
                <div className="w-4 h-4 border border-solid border-red-500 rounded-full bg-red-100"></div>
                <span className="text-xs text-gray-700">Highest Price.</span>
              </span>
            </div>
          </div>
          <div
            className="w-6 h-6 bg-baseColor-primary rounded-sm cursor-pointer"
            onClick={onClose}
          >
            <p className="text-center py-1 text-white text-xs">X</p>
          </div>
        </div>
        <div className="overflow-x-auto w-full rounded-lg">
          <div className="w-full min-h-[calc(100vh-250px)] max-h-[calc(100vh-120px)] overflow-y-scroll">
            {isLoading ? (
              <div className="w-full">
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="animate-pulse flex space-x-4 mb-4">
                    <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                    <div className="flex-1 space-y-6 py-1">
                      <div className="h-4 bg-slate-200 rounded"></div>
                      <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-4 bg-slate-200 rounded col-span-2"></div>
                          <div className="h-4 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div className="h-4 bg-slate-200 rounded"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className={
                  supplierList?.length > 10
                    ? `min-w-[4900px]`
                    : supplierList?.length > 6
                      ? `min-w-[3900px]`
                      : supplierList?.length > 4
                        ? `min-w-[2900px]`
                        : supplierList?.length > 1
                          ? `min-w-[1800px]`
                          : `min-w-[750px] sm:min-w-[900px] md:min-w-[1100px]`
                }
              >
                <table className="table-auto relative min-w-full border-collapse border border-slate-300 z-0">
                  <thead className="bg-baseColor-primary sticky top-0 text-white text-xs 2xl:text-sm z-30">
                    <tr>
                      <th
                        rowSpan={2}
                        className="p-0 lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] bg-baseColor-primary z-40 border-r border-[#acaaaa] align-middle"
                      >
                        <div className="flex w-full h-full items-stretch">
                          <div className="w-[35px] sm:w-[45px] py-1 flex justify-center items-center text-center border-r border-[#acaaaa] shrink-0">
                            S.N.
                          </div>
                          <div className="flex-1 py-1 flex justify-center items-center text-left border-r border-[#acaaaa] px-1">
                            Product
                          </div>
                          <div className="w-[50px] sm:w-[65px] md:w-[75px] py-1 flex justify-center items-center text-right border-r border-[#acaaaa] shrink-0 pr-1">
                            Unit
                          </div>
                          <div className="w-[45px] sm:w-[55px] md:w-[65px] py-1 flex justify-center items-center text-right pr-1 shrink-0">
                            Qty
                          </div>
                        </div>
                      </th>

                      {supplierList.map((sub, index) => (
                        <th
                          key={`supplier-top-${index}`}
                          colSpan={3}
                          className="border-r border-[#acaaaa] px-2 py-1 bg-baseColor-primary border-b border-white/20 w-[350px] min-w-[350px]"
                        >
                          <div className="flex justify-between items-center text-xs w-full">
                            <div className="text-left shrink-0 max-w-[160px]">
                              <p className="font-semibold text-white text-xs truncate">
                                {sub?.name || `Supplier ${index + 1}`}
                              </p>
                              <p className="text-[10px] font-light opacity-90 truncate">
                                {sub?.type || ""}
                              </p>
                            </div>
                            <div className="text-left text-[9px] leading-3 shrink-0">
                              <div>Ref : {sub?.ref || "#"}</div>
                              <div>
                                Prepared By :{" "}
                                <span className="capitalize">
                                  {sub?.preparedBy || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="text-left text-[9px] leading-3 shrink-0">
                              <div>
                                {sub?.date ? (
                                  <NuDate
                                    value={sub?.date}
                                    format="DD-MMM-YYYY"
                                  />
                                ) : (
                                  "date"
                                )}
                              </div>
                              <div>
                                Purchaser :{" "}
                                <span className="capitalize">
                                  {sub?.purchaser || "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </th>
                      ))}
                    </tr>
                    <tr>
                      {supplierList.map((sub, index) => (
                        <React.Fragment key={`supplier-sub-${index}`}>
                          <th className="w-[140px] min-w-[140px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                            <div className="flex items-center justify-center gap-1 relative">
                              <span>Unit Price</span>
                              <HeaderInfoTooltip sub={sub} />
                            </div>
                          </th>
                          <th className="w-[60px] min-w-[60px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                            GP
                          </th>
                          <th className="w-[150px] min-w-[150px] py-1.5 border-r border-[#acaaaa] bg-baseColor-primary text-center font-semibold text-xs">
                            Selling Price
                          </th>
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="">
                    {dataView &&
                      dataView.map((item, index) => (
                        <tr
                          key={index}
                          className="odd:bg-white even:bg-slate-50 text-xs 2xl:text-sm border-collapse border border-slate-300"
                        >
                          <td
                            className={`text-center lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] z-20 ${index % 2 !== 0 ? "bg-slate-50" : "bg-white"
                              }`}
                          >
                            <div className="flex w-full items-center py-1">
                              <div className="w-[35px] sm:w-[45px] text-center border-r border-[#acaaaa] flex justify-center items-center shrink-0">
                                {item.display_sno || item.sno || item.sNo}
                              </div>
                              <div className="flex-1 text-left border-r border-[#acaaaa] flex justify-start px-1 sm:px-2 items-center">
                                <div className="truncate whitespace-normal line-clamp-2">
                                  {item.name}
                                  {item.alternate === true && (
                                    <span className="block text-green-500 w-[90px] rounded-md font-normal text-[8px]">
                                      Alternate Item
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="w-[50px] sm:w-[65px] md:w-[75px] text-center border-r border-[#acaaaa] flex justify-center items-center shrink-0">
                                {item.unit}
                              </div>
                              <div className="w-[45px] sm:w-[55px] md:w-[65px] text-center pr-1 flex justify-center items-center shrink-0">
                                {item.requestedQty}
                              </div>
                            </div>
                          </td>

                          {supplierList.map((sub, sIndex) => {
                            const supplier = stateValue.find(
                              (i) =>
                                i.productId === item.id &&
                                i.quoteId === sub.quoteId,
                            );
                            if (supplier) {
                              return (
                                <React.Fragment
                                  key={`dynamic-cell-${index}-${sIndex}`}
                                >
                                  <td
                                    className={`py-1 text-center border-collapse border-x border-y-0 w-[140px] border-slate-300`}
                                  >
                                    <div className="flex justify-center text-center items-center">
                                      <InfoTooltip supplier={supplier} />

                                      <input
                                        type="checkbox"
                                        checked={supplier.isSelected}
                                        disabled={true}
                                      />
                                      {supplier?.LCSP
                                        ? parseFloat(
                                          supplier.LCSP,
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                        : "-"}
                                    </div>
                                    <div className="text-[10px] text-gray-500">
                                      {supplier?.leadTime ||
                                        "Lead Time : None"}
                                    </div>
                                  </td>
                                  <td
                                    className={`py-1 text-center border-collapse border-x border-y-0 w-[60px] border-slate-300`}
                                  >
                                    <div className="w-full h-full flex justify-evenly px-1">
                                      <input
                                        type="number"
                                        className="w-full py-0.5 px-1 text-center focus:outline-none rounded bg-slate-200"
                                        value={parseFloat(supplier.gp)}
                                        disabled={true}
                                      />
                                    </div>
                                  </td>
                                  <td
                                    className={`py-1 text-center border-collapse border-x border-y-0 w-[150px] border-slate-300 ${supplier.isLow === true &&
                                      supplier.isHigh === true
                                      ? "bg-green-100"
                                      : supplier.isHigh === true &&
                                        supplier?.LCSP > 0
                                        ? "bg-red-100"
                                        : supplier.isLow === true &&
                                          supplier?.LCSP > 0
                                          ? "bg-green-100"
                                          : ""
                                      }`}
                                  >
                                    <div className="w-full h-full">
                                      <NuAmount
                                        value={
                                          supplier?.sellingPrice || 0
                                        }
                                      />
                                    </div>
                                    <div className="text-[10px] text-gray-500">
                                      Total :{" "}
                                      <NuAmount
                                        value={
                                          parseFloat(
                                            supplier?.sellingPrice,
                                          ) *
                                          parseFloat(
                                            item.requestedQty,
                                          ) || 0
                                        }
                                      />
                                      {supplier.isLow !== true &&
                                        supplier?.sellingPrice > 0 && (
                                          <span className="ml-1 w-full text-[10px] text-red-700 truncate">
                                            {CalPercentage(
                                              stateValue,
                                              supplier,
                                              item?.name,
                                            )}
                                          </span>
                                        )}
                                    </div>
                                  </td>
                                </React.Fragment>
                              );
                            } else {
                              return (
                                <React.Fragment
                                  key={`dynamic-cell-${index}-${sIndex}`}
                                >
                                  <td
                                    colSpan={3}
                                    className="border-collapse border-x border-y-0 border-slate-300"
                                  ></td>
                                </React.Fragment>
                              );
                            }
                          })}
                        </tr>
                      ))}
                    <tr className="bg-white text-xs 2xl:text-sm font-bold">
                      <td className="py-1 text-center lg:sticky lg:left-0 w-[270px] min-w-[270px] sm:w-[365px] sm:min-w-[365px] md:w-[445px] md:min-w-[445px] lg:w-[470px] lg:min-w-[470px] bg-white z-[0]"></td>

                      {supplierList?.map((sub, supplierIndex) => {
                        const totalPrice = stateValue
                          .filter((i) => i.quoteId === sub.quoteId)
                          .reduce(
                            (total, supplier) =>
                              total +
                              parseFloat(supplier.sellingPrice || 0) *
                              parseFloat(supplier?.requestedQty),
                            0,
                          );

                        return (
                          <React.Fragment
                            key={`total-row-${supplierIndex}`}
                          >
                            <td className="py-1 text-center w-[140px] border-r border-slate-200"></td>
                            <td className="py-1 text-center w-[60px] border-r border-slate-200"></td>
                            <td className="py-1 text-center w-[150px] px-2 border-r border-slate-200">
                              <div className="flex gap-2 text-[10px] text-gray-500 justify-center">
                                <span>Total:</span>
                                <NuAmount value={totalPrice} />
                              </div>
                            </td>
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteComparisonModal;
